<template>
  <v-dialog
    v-model="isOpenPracticeHw"
    max-width="230"
    persistent
    :retain-focus="false"
  >
    <v-card class="quick-view">
      <v-card-title
        class="font-weight-bold white--text pa-2"
        style="background: #ff5252; font-size: 14px"
      >
        {{ lessonHomework.lessonTitle }}
      </v-card-title>
      <v-card-text class="my-5 pa-0 d-flex card-text-body">
        <div class="px-2 w-full ml-4">
          <div
            v-for="(practice,index) in lessonHomework.practices"
            :key="practice.id"
            class="py-2 d-flex justify-start"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="mr-3"
            >
              <rect width="24" height="24" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlink:href="#image0_13861_119"
                    transform="scale(0.0416667)"
                  />
                </pattern>
                <image
                  id="image0_13861_119"
                  width="24"
                  height="24"
                  xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAMsSURBVEiJ7ZU/qNZlFMc/58/vvdeSUIgChTKCcijHCop6oSEQhyIaaoiWaojCIRJckgraypBoiBprMFpyaHAoCqIgiKBAKTEQMqISie7b/Z0/Dve9pu8VlNY60/MceM73fL/fw3ng/7hMyPrh5+fuf6bTdlUYjE6nQDo1GhVGh0Wnf8hoUikP9eje6ZBCjU6FQRqdDqHf3nb8lTcBpA+gv/x5740k7wuTx5gBLDH7G2CZtTvkqIOMS69VaEn48xGMsAQzkJWlLdJytoyazZbQkPey7NFdx/wn/zXvuNuW4vUadZt0XJNLerBjFZsYxAo9cTocU06Xjx9oD9x05N1j68yPT59+uTat3tVpcesXh3YL9He3v3CDB4e/v6X3ukzKGOOIlt3nK34yvQ4IihGkDLOIOOmuO7WZibAzJS7W2PNhms8QHvjhzme38+WhU+J5rIVPq9vdPahyupvZcm9RfFoAKNrjmWGYzLpjCnIGrTO2YKJanE3ksCQ7wsrnoLQIlOJ4QIGKYcYWCZlK1t5yPwiOyvhghQF6Gvh4w5RM6iof45EU3cE4rLNCBbTAcdAqWuC6/V9/A0znb6eLxU49ufuJWgSw8beuPq5qk2XLNVYepPRa43iAB+KxWG9jWKFDLnhQyCT2YBfkPVAv8GDugdK6qO4l6g9JLuTUkxJQSTCb54qWtbpzDxytvgIGIxvamOvdQNXsPGiK4OsAWkD9OwbiQQvQDTZcBFoF7g5VRS+6d0mE3MBAPTe3cG1hmxnzAlCBin9MVl/s7RIxFBeZCYhn47lPLLf71cPZdQD1wD3WJVL6CjxQSxaJ2pD7Ed4A3tn29uHf11gVKQGl6wzqysZ0SHSBwfWHjh4Vz7cQe/V80nM+piDjR5unterTLrunw34kbG1Fz1dxjw5hVGrl6JskBqmUv3octOYrvcNg/qZSIPzmDPu8Vv0Tx0GIrRK9r5StqGAlNKvQjphACzSbGPKlElrFXyxixcRICmkFAhNoDKn6Q4zHy8Hd80Qiy9XyFBTYSE8aC6MoSgp0BHV05CuAEtkjFNCoNKW19kmRWEMhtBaWnLi87v/5OAcVoaw0K+36AAAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg>
            <span
              @click="openNewTab(practice.lmsLinkPractice)"
              class="font-weight-bold mr-2 practice-result-link"
              >{{ `Bài tập ${index + 1}${practice.time ? ":" : ""}` }}
            </span>
            <span
              class="practice-result-link"
              v-if="practice.time"
              @click="openNewTab(practice.lmsLinkPracticeResult)"
            >
              {{ practice.noCorrect || 0 }}/{{ practice.noQuestion }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn @click="closeModal()" class="btn-close"> Đóng </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
.btn-close {
  color: #2b2b2b !important;
  border-radius: 25px;
  font-weight: bold;
  padding: 0 15px !important;
  height: 35px !important;
  background-color: #fcc2ba !important;
}
.practice-result-link {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #0088ff;
  cursor: pointer;
}
.card-text-body {
  max-height: 227px;
  overflow-y: auto;
  font-size: 14px !important;
}

.card-text-body::-webkit-scrollbar {
  width: 5px;
  background-color: #fff;
}

.card-text-body::-webkit-scrollbar-thumb {
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
  background-color: #d9d9d9;
}
</style>

<script>
export default {
  props: {},
  data() {
    return {
      lessonHomework: {},
      isOpenPracticeHw: false,
    };
  },
  created() {
    Bus.$on('openModalPracticeHw', (lessonHomework) => {
      this.lessonHomework = lessonHomework;
      this.isOpenPracticeHw = true;
    });
  },
  methods: {
    closeModal() {
      this.isOpenPracticeHw = false;
    },
    openNewTab(url) {
      this.$emit('openInNewTab', url);
    },
  },
  destroyed() {
    Bus.$off('openModalPracticeHw');
  },
};
</script>
